import * as React from "react";

const SvgIcnGenericDoc = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M21 13h10a2 2 0 012 2v18a2 2 0 01-2 2H17a2 2 0 01-2-2V19l6-6z" fill="currentColor" />
            <path d="M21.5 14L16 19.5V33a1 1 0 001 1h14a1 1 0 001-1V15a1 1 0 00-1-1h-9.5z" fill="#FFF" />
            <path
                d="M21.5 29a.5.5 0 110 1h-2a.5.5 0 110-1h2zm5-2a.5.5 0 110 1h-7a.5.5 0 110-1h7zm-1-2a.5.5 0 110 1h-6a.5.5 0 110-1h6zm3-2a.5.5 0 110 1h-9a.5.5 0 110-1h9zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zM22 13v7h-7v-1h6v-6z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnGenericDoc;
